import PropTypes from 'prop-types'
import {useState} from 'react'
import {Map, List} from 'immutable'

import TfaWizard from './tfa_setup/TfaWizard'
import TfaOnboardingPrompt from './TfaOnboardingPrompt'

import MixpanelLogger from '../../../../lib/MixpanelLogger'
import {isMandatoryTfaEnabled} from '../../../../lib/tfaTools'

import './tfaSetup.scss'

const TfaSetup = props => {
  const [setupStarted, setSetupStarted] = useState(false)
  const appEnrollmentOnly = props.userConfig.get('admin') || props.userConfig.get('quarterback') || props.userConfig.get('account-manager')

  const logMixpanelEvent = name => {
    MixpanelLogger.track(name)
  }

  const startSetup = () => {
    logMixpanelEvent('2fa_setup_opt_in')
    setSetupStarted(true)
  }

  const cancelSetup = event => {
    if (event) event.preventDefault()

    logMixpanelEvent('2fa_setup_opt_out')
    setSetupStarted(false)
  }

  const disableSkip = () => (
    isMandatoryTfaEnabled({organizationConfig: props.organizationConfig, firmConfig: props.firmConfig}) ||
    props.isQuarterback ||
    (props.firmUser && props.isFuneralHome && !props.isWhitelistedFirmUser) ||
    appEnrollmentOnly
  )

  const canCancelSetup = !disableSkip()

  const exitOnboarding = event => {
    if (event) event.preventDefault()

    logMixpanelEvent('2fa_setup_opt_out')
    props.exitTfa(event)
  }

  return (
    <div className='tfa-setup tfa-setup-onboarding'>
      {
        setupStarted ?
          <TfaWizard
            appEnrollmentOnly={appEnrollmentOnly}
            exitTfa={props.exitTfa}
            onCancelSetup={canCancelSetup ? cancelSetup : null}
            currentUser={props.currentUser}
            tfaConfig={props.tfaConfig}
            readEndpoint={props.readEndpoint}
            tfaEnrollments={props.tfaEnrollments}
            userConfig={props.userConfig}
          /> :
          <TfaOnboardingPrompt
            onPrimaryAction={startSetup}
            onSecondaryAction={exitOnboarding}
            showSecondaryAction={canCancelSetup}
          />
      }
    </div>
  )
}

TfaSetup.propTypes = {
  exitTfa: PropTypes.func,
  firmUser: PropTypes.bool,
  onboarding: PropTypes.bool,
  currentUser: PropTypes.object,
  firmConfig: PropTypes.instanceOf(Map),
  organizationConfig: PropTypes.instanceOf(Map),
  isQuarterback: PropTypes.bool,
  tfaConfig: PropTypes.object,
  wizardActive: PropTypes.bool,
  isFuneralHome: PropTypes.bool,
  isWhitelistedFirmUser: PropTypes.bool,
  readEndpoint: PropTypes.func,
  tfaEnrollments: PropTypes.instanceOf(List),
  userConfig: PropTypes.instanceOf(Map)
}

TfaSetup.defaultProps = {
  onboarding: false,
  wizardActive: false,
  firmConfig: Map(),
  organizationConfig: Map(),
  isWhitelistedFirmUser: false
}

export default TfaSetup
